import { combineReducers } from "redux";
import { routingReducer as router } from "modules/routing/routing-reducer";
import { formReducer as form } from "modules/forms/forms-reducer";

import user from "modules/user/user-reducer";
import auth from "modules/auth/auth-reducer";
import localeConfig from "modules/i18n/locale-reducer";
import diagnostic from "modules/diagnostic/diagnostic-reducer";
import modal from "modules/modal/modal-reducer";
import entityRepository from "modules/entity-repository/entity-repository-reducer";
import brand from "modules/brand/brand-reducer";
import common from "modules/common/common-reducer";

export const rootReducer = combineReducers({
  router,
  form,
  modal,
  user,
  auth,
  localeConfig,
  diagnostic,
  entityRepository,
  brand,
  common
});



// WEBPACK FOOTER //
// ./src/modules/root/root-reducer.js